export default __webpack_public_path__ + "static/media/Tahseel-logo-white.4566099b.svg";